import { Button, Input } from "@biteship/atom";
import { API_SHIPPING } from "@config";
import { ArrowPathIcon, DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import { generateClientAuthToken } from "@store/action/openCourier";
import { useEffect, useState, useCallback, useMemo } from "react";

/**
 * 
 * @param {Object} props
 * @param {string} props.authToken - client authentication token
 * @param {string} props.openCourierId - open courier id
 * @returns 
 */
export default function TrackingStatus({
  authToken,
  openCourierId,
}) {
  const [updatedAuthToken, setUpdatedAuthToken] = useState("");
  const webhookUrl = useMemo(() => `${API_SHIPPING}/v1/open_couriers/orders/:orderId/update_status`, []);

  useEffect(() => {
    setUpdatedAuthToken(authToken);
  }, [authToken]);

  const handleCopyToken = useCallback(() => {
    if (updatedAuthToken) {
      navigator.clipboard.writeText(updatedAuthToken);
      alert("Token berhasil disalin");
    }
  }, [updatedAuthToken]);

  const handleCopyWebhookUrl = useCallback(() => {
    navigator.clipboard.writeText(webhookUrl);
    alert("Order status webhook URL berhasil disalin");
  }, [webhookUrl]);

  const handleGenerateTokenClick = useCallback(() => {
    if (!window.confirm("Apakah anda yakin ingin generate client authentication token baru?")) return;

    generateClientAuthToken(openCourierId)
      .then((token) => {
        setUpdatedAuthToken(token);
        alert("Token berhasil di generate");
      }).catch((error) => {
        alert(error?.response?.data?.error || "Token gagal di generate");
      });
  }, [openCourierId]);

  return (
    <div className="space-y-4 w-full">
      <h2 className="text-sm text-gray-900 font-semibold mb-0">Update Status ke Biteship</h2>

      <div>
        <div className="flex space-x-4 w-full md:w-2/3 items-end">
          <Input
            label="Kirimkan status tracking terbaru Anda ke URL dibawah ini"
            value={webhookUrl}
            className="w-full"
            disabled
          />
          <Button 
            title={<DocumentDuplicateIcon className="w-6 h-6" />}
            className="h-fit justify-center md:w-auto py-2.5"
            onClick={handleCopyWebhookUrl}
          />
        </div>
        <p className="text-sm text-gray-700 mt-2">Sesuaikan nilai <code className="text-xs bg-gray-300 p-1 rounded">orderId</code> dengan yang Biteship kirim saat pembuatan pengiriman/order.</p>
      </div>

      <div>
        <div className="flex space-x-4 w-full md:w-2/3 items-end">
          { updatedAuthToken ? (
            <>
              <Input
                label="Client Authentication Token"
                value={updatedAuthToken}
                className="w-full"
                disabled
              />
              <div className="flex space-x-2">
                <Button 
                  title={<ArrowPathIcon className="w-6 h-6" />}
                  className={`h-fit justify-center md:w-auto py-2.5`}
                  onClick={handleGenerateTokenClick}
                  secondary
                />
                <Button 
                  title={<DocumentDuplicateIcon className="w-6 h-6" />}
                  className="h-fit justify-center md:w-auto py-2.5"
                  onClick={handleCopyToken}
                />
              </div>
            </>
          ) : (
            <Button 
              title={"Generate Authentication Token"}
              className={`h-fit justify-center md:w-auto`}
              onClick={handleGenerateTokenClick}
            />
          )}
        </div>
        <p className="text-sm text-gray-700 mt-2">Biteship akan memvalidasi request headers Anda pada key <code className="text-xs bg-gray-300 p-1 rounded">Authorization</code>.</p>
      </div>
      
    </div>
  )
}